import {
    Tooltip as WDSTooltip,
    type TooltipProps as WdsTooltipProps,
    type TooltipContentProps as WdsTooltipContentProps,
} from "@datamole/wds-component-tooltip";
import { type ReactNode } from "react";
import { styled } from "styled-components";

type Props = WdsTooltipProps & {
    content: ReactNode;
    side?: WdsTooltipContentProps["side"];
    align?: WdsTooltipContentProps["align"];
    alignOffset?: WdsTooltipContentProps["alignOffset"];
    sideOffset?: WdsTooltipContentProps["sideOffset"];
    asChild?: boolean;
    className?: string;
};

const Tooltip = (props: Props) => {
    const {
        content,
        children,
        disableHoverableContent = true,
        side = "top",
        align = "start",
        alignOffset = 2,
        sideOffset = 2,
        asChild = false,
        className,
        ...otherProps
    } = props;

    return (
        <WDSTooltip {...otherProps} disableHoverableContent={disableHoverableContent}>
            <WDSTooltip.Trigger asChild={asChild}>{children}</WDSTooltip.Trigger>
            <TooltipContentStyled
                side={side}
                align={align}
                alignOffset={alignOffset}
                sideOffset={sideOffset}
                className={className}
            >
                {content}
                <WDSTooltip.Content.Arrow />
            </TooltipContentStyled>
        </WDSTooltip>
    );
};

export { Tooltip };
export type { Props as TooltipProps };

const TooltipContentStyled = styled(WDSTooltip.Content)`
    z-index: ${({ theme }) => theme.zIndex.dropdown};
`;
